import { render, staticRenderFns } from "./TaskController.vue?vue&type=template&id=2b0e3dd4"
import script from "./TaskController.vue?vue&type=script&lang=js"
export * from "./TaskController.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports